import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="bottom-center"
      offset={24}
      mobileOffset={24}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg !px-3 !py-2 text-xs max-w-[280px]",
          description: "group-[.toast]:text-muted-foreground text-xs",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground !h-7 !px-2 text-xs",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground !h-7 !px-2 text-xs",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
